import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const SETTINGS_STRINGS = appStrings.modules.accountSettings.settings;

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: SETTINGS_STRINGS.sections.activationCode.title,
    description: SETTINGS_STRINGS.sections.activationCode.description,
  });
};
